import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";


interface XmlHistoryEntry {
  chave: string;
  lastUsed: number;
}

interface PrenotaStore {
  xmlHistory: string[];
  isLoading: boolean;
  addXml: (chave: string) => void;
  clearXml: () => void;
}

const XML_HISTORY_LIMIT = 20;

export const usePrenotaStore = create<PrenotaStore>()(
  devtools(
    persist(
      (set) => ({
        xmlHistory: [],
        isLoading: false,

        addXml: (chave) => {
          if (!chave || chave.length !== 44) return;
          let entries: XmlHistoryEntry[] = [];
          try {
            entries = JSON.parse(
              localStorage.getItem("prenota-xml-history") || "[]"
            );
          } catch {}
          entries = entries.filter((entry) => entry.chave !== chave);
          entries.unshift({ chave, lastUsed: Date.now() });
          entries = entries.slice(0, XML_HISTORY_LIMIT);
          localStorage.setItem("prenota-xml-history", JSON.stringify(entries));
          set({ xmlHistory: entries.map((e) => e.chave) });
        },
        clearXml: () => {
          localStorage.setItem("prenota-xml-history", "[]");
          set({ xmlHistory: [] });
        },
      }),
      { name: "prenota" }
    ),
    { name: "prenota-store" }
  )
);

/**
 * Hook de histórico de chaves XML (NF-e/CT-e) usando Zustand.
 * Permite salvar, listar e limpar histórico local de chaves.
 * Compatível com a versão anterior do IndexedDB.
 */
export function useXmlHistory() {
  const { xmlHistory, addXml, clearXml } = usePrenotaStore();

  // Como Zustand é síncrono, não há loading real
  const isLoading = false;

  return {
    xmlHistory,
    isLoading,
    addToHistory: addXml, // Mantém compatibilidade com nome antigo
    clearHistory: clearXml,
  };
}
